import { INTERNAL_ROLES, ROLE_HINTS, ROLE_LABELS } from "@/lib/team";

/** Role picker. Super Admin is only selectable by the main owner account (the server enforces it too). */
export function RoleSelect({ value, onChange, actorIsOwner, testid, exclude }) {
  return (
    <div className="space-y-2" role="radiogroup" data-testid={testid}>
      {INTERNAL_ROLES.filter((r) => r !== exclude).map((r) => {
        const locked = r === "super_admin" && !actorIsOwner;
        return (
          <label key={r} className={`flex items-start gap-3 rounded-xl border px-3 py-2.5 transition-colors ${
            value === r ? "border-cyan-500 bg-cyan-50/60" : "border-slate-200 hover:bg-white/60"} ${locked ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
            <input type="radio" name={testid} value={r} checked={value === r} disabled={locked}
              onChange={() => onChange(r)} className="mt-1 accent-cyan-600" data-testid={`${testid}-${r}`} />
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-slate-900">{ROLE_LABELS[r]}</span>
              <span className="block text-xs text-slate-500">{locked ? "Only the main owner account can grant Super Admin" : ROLE_HINTS[r]}</span>
            </span>
          </label>
        );
      })}
    </div>
  );
}
